import React, { useState } from 'react';
const PremiumPicks = () => {
  const [activeCity, setActiveCity] = useState('Gurugram');

  const cities = ['Gurugram', 'Noida'];

  const properties = [
    {
      title: "Satya Levante Residences",
      location: "Sector 104, Dwarka Expressway",
      price: "Starting From Rs. 2.99 Cr.",
      image: "https://100real.xyz/Images/Store/1749795554846-compressed_Untitled.jpg"
    },
    {
      title: "Tulip Melrose",
      location: "Sector 70, Southern Peripheral...",
      price: "Starting From Rs. 4.66 Cr.",
      image: "https://100real.xyz/Images/Store/1749819764878-BLD.jpg"
    },
    {
      title: "Tulip Monsella",
      location: "Sector 53, Golf Course Road",
      price: "Starting From Rs. 6.89 Cr.",
      image: "https://100real.xyz/Images/Store/1749727910227-aubburn_at_sarova-kandivali_east-mumbai-s_d_corporation_private_limited.png"
    },
    {
      title: "Whiteland The Westin Reside",
      location: "Sector 103, Dwarka Expressway",
      price: "Starting From Rs. 6.5 Cr.",
      image: "https://100real.xyz/Images/Store/1748615662528-about-page-main-image-first-brick.png"
    }
  ];

  return (
    <section className="premium-picks-container">
      <div className="header-content">
        <h2 className="section-title">Best Picks</h2>
        <p className="section-subtitle">Explore the premium homes across Gurugram & Noida.</p>
      </div>

      <div className="city-tabs">
        {cities.map((city) => (
          <button
            key={city}
            className={`tab-button ${activeCity === city ? 'active' : ''}`}
            onClick={() => setActiveCity(city)}
          >
            {city}
          </button>
        ))}
      </div>

      <div className="property-grid">
        {properties.map((item, index) => (
          <div key={index} className="property-card">
            <div className="image-wrapper">
              <img src={item.image} alt={item.title} />
            </div>
            <div className="card-details">
              <h3>{item.title}</h3>
              <p className="location">{item.location}</p>
              <p className="price">{item.price}</p>
            </div>
          </div>
        ))}
      </div>
    </section>
  );
};

export default PremiumPicks;